import React, { useState, useEffect } from 'react';
import Milestone from '../Milestone';
import Carousel2 from '../Carousel2';
import { ParallaxProvider } from 'react-scroll-parallax';
import GTranslate from '../GTanslate';

const History = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [hideIcon, setHideIcon] = useState(false);

  const handleScroll = () => {
    const carousel = document.getElementById('carousel2');
    
    if (carousel) {
      const carouselTop = carousel.getBoundingClientRect().top;
      if (carouselTop <= window.innerHeight / 2) {
        setHideIcon(true);
      } else {
        setHideIcon(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <main className="min-h-screen bg-gradient-to-b from-gray-50 via-white to-gray-50 font-montserrat">
      {/* Fixed Language Selector */}
      <div className="fixed top-6 right-6 z-50">
          <GTranslate />
        
      </div>

      {/* Hero Section */}
      <section className="relative pt-24 pb-16 overflow-hidden bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="w-16 h-1 bg-gradient-to-r from-red-600 to-red-700 rounded-full" />
              <span className="text-sm font-semibold text-red-700 uppercase tracking-wider">Tarihçemiz</span>
              <div className="w-16 h-1 bg-gradient-to-r from-red-600 to-red-700 rounded-full" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              70+ Yıllık <span className="text-red-700">Başarı Hikayesi</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              1949'dan günümüze, kompozit teknolojilerinde liderlik yolculuğumuz
            </p>
          </div>
        </div>
      </section>

      {/* Timeline Carousel Section */}
      <section className="py-12 bg-white border-y border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Zaman <span className="text-red-700">Tünelimiz</span>
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Her dönemde yenilik ve mükemmelliği hedefleyen adımlarımız
            </p>
          </div>
          <Carousel2 id="carousel2" />
        </div>
      </section>

      {/* Milestone Timeline Section */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Dönüm <span className="text-red-700">Noktalarımız</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Kuruluşumuzdan bugüne, kompozit sektörüne yön veren kilometre taşlarımız
            </p>
          </div>
          <ParallaxProvider>
            <Milestone hideIcon={hideIcon} />
          </ParallaxProvider>
        </div>
      </section>

      {/* Legacy Section */}
      {/* <section className="py-20 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
<div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' viewBox=\'0 0 100 100\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z\' fill=\'%23dc2626\' fill-opacity=\'0.05\' fill-rule=\'evenodd\'/%3E%3C/svg%3E')]" />        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h3 className="text-3xl font-bold text-white mb-8">
            Geleceği Şekillendiren <span className="text-red-300">Geçmiş</span>
          </h3>
          <p className="text-xl text-gray-300 leading-relaxed mb-12">
            Her başarılı gelecek, sağlam bir geçmiş üzerine inşa edilir. 
            70+ yıllık deneyimimizle, kompozit teknolojilerinin geleceğini şekillendirmeye devam ediyoruz.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { value: '70+', label: 'Yıl', desc: 'Deneyim' },
              { value: '3', label: 'Nesil', desc: 'Aile Şirketi' },
              { value: '6', label: 'Kıta', desc: 'Varlık' },
              { value: '40+', label: 'Ülke', desc: 'Operasyon' }
            ].map((item, idx) => (
              <div key={idx} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="text-3xl font-bold text-white mb-2">{item.value}</div>
                <div className="text-lg font-semibold text-red-300">{item.label}</div>
                <div className="text-sm text-gray-400 mt-1">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
    </main>
  );
};

export default History;